import { createContext } from '../../utils/create-context';
// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export const [ComboboxProvider, useComboboxContext] = createContext({
    hookName: 'useComboboxContext',
    providerName: '<ComboboxProvider />',
});
